// List all generic functions here

export const unAllowedJobsToAbort = ['requested', 'dispatched']

// Allowed image type
export const ALLOWED_IMG_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];

// SVG image format tag : base64
export const SVG_BASE64_FORMAT = 'data:image/svg;base64,';

export const GITHUB_WORKFLOWS_EXEC = '/github-workflows/execute';
export const WORKFLOW_QG = '/quality-gate';
export const WORKFLOW_PREREQUISITE = '/workflow-prerequisite';

export const GITHUB_URL = 'https://github.com/';

export const ISSUE_TMPL_PATH = '.github/ISSUE_TEMPLATE';

// Enhanced regex to handle all cases: http/https, case insensitive, with validation
export const githubPattern = /^(https?:\/\/)?github\.com\/?/i;

// Max limit of file 1 mb
export function imgSize(file: any) {
  return file.size / (1024 * 1024);
}

//Removes empty properties from an given object
export function removeEmptyProps(object: any) {
  for (let [key, value] of Object.entries(object)) {
    if (value === '' || value === null || value === undefined) delete object[key]
  }
  return Object.keys(object).length === 0 ? '' : object
}

export const wfRun = 'wfRun';
export const prerequisite = 'prerequisite';